import { Component, OnInit } from "@angular/core";
import { ResultStatus } from "@app/core/models/result-status";
import { AgentSkillService } from "@app/core/services/agent-skill.service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { HelperService } from "@app/core/services/helper.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-endorse-agent-skills",
  templateUrl: "./endorse-agent-skills.component.html",
  styleUrls: ["./endorse-agent-skills.component.scss"],
})
export class EndorseAgentSkillsComponent implements OnInit {
  agentID: any;
  agentFirstName = "";
  agentLastName = "";
  agentEndorsedSkillList = [];
  constructor(
    public modalRef: BsModalRef,
    private modalService: BsModalService,
    private agentSkillService: AgentSkillService,
    private toaster: ToastrService,
    private authService: AuthenticationService,
    private helperService: HelperService
  ) {
    this.agentID = this.modalService.config.initialState["agentId"];
    this.agentFirstName = this.modalService.config.initialState[
      "agentFirstName"
    ];
    this.agentLastName = this.modalService.config.initialState["agentLastName"];
  }

  ngOnInit() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.agentID)) {
      this.getAgentEndorseSkills();
    }
  }

  closeModal() {
    this.modalRef.hide();
  }

  getAgentEndorseSkills() {
    this.agentSkillService.getAgentEndorseSkills(this.agentID).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.agentEndorsedSkillList = result.Data;
          console.log(this.agentEndorsedSkillList);
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }

  manageEndorsedSkill(SkillId, endorseAgentSkillId, isEndorsed) {
    if (isEndorsed) {
      this.deleteEndorsedSkill(endorseAgentSkillId);
    } else {
      this.endorseAgentSkill(SkillId);
    }
  }

  endorseAgentSkill(skillId) {
    const postData = {
      AgentId: this.agentID,
      SkillId: skillId,
      EndorseBy: +this.authService.getUserInformation()["ID"],
    };
    this.agentSkillService.postAgentEndorseSkills(postData).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.getAgentEndorseSkills();
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }

  deleteEndorsedSkill(endorsedSkillId) {
    this.agentSkillService.deleteAgentEndorsedSkill(endorsedSkillId).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.getAgentEndorseSkills();
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }
}
